export enum FunctionalType {
	Rotation = 'rotation',
	PlansCompare = 'plansCompare',
	SendExecution = 'sendExecution',
	Analytics = 'analytics',
	PlanogramsCompare = 'planogramsCompare',
	PlanogramCopying = 'planogramCopying',
	PlanogramExtendedCopying = 'planogramExtendedCopying',
	RevertPlanogram = 'revertPlanogram',
	Blocks = 'blocks',
	ProductsHighlightsControl = 'productsHighlightsControl',
	ProductsHighlightsPlanogramView = 'productsHighlightsPlanogramView',
	ProductsHighlightsPlanogramEdit = 'productsHighlightsPlanogramEdit',
	PlanogramHistory = 'planogramHistory',
	Control = 'control',
	PlanAnalytics = 'planAnalytics',
	PlanogramAnalytics = 'planogramAnalytics',
	ReversedLayout = 'reversedLayout',
	MasterPositions = 'masterPositions',
	ArchiveProducts = 'archiveProducts',
	PlanogramGroups = 'planogramGroups',
	StorePlans = 'storePlans'
}